<template>
    <div class="page-head">
        <div class="container">
            <div class="row">
                <div class="page-head-content">
                    <h1 class="page-title">Hello : <span class="orange strong">{{store.$state.user.name}}</span></h1>
                </div>
            </div>
        </div>
    </div>

    <div class="content-area user-profiel" style="background-color: #FCFCFC;">&nbsp;
        <div class="container">
            <div class="row">
                <div class="col-sm-10 col-sm-offset-1 profiel-container">

                    <form action="#" method="post" @submit.prevent="submit">
                        <div class="profiel-header">
                            <h3>
                                <b>BUILD</b> YOUR PROFILE <br>
                                <small>This information will let us know more about you.</small>
                            </h3>
                            <hr>
                        </div>

                        <div class="clear">

                            <div class="col-sm-8 col-sm-offset-3 padding-top-25">

                                <div class="form-group">
                                    <label>Name <small>(required)</small></label>
                                    <input name="name" type="text" class="form-control" placeholder="Andrew..." v-model="form.name" />
                                    <span class="invalid-feedback" v-if="errors && errors.name">{{errors.name[0]}}</span>
                                </div>
                                <div class="form-group">
                                    <label>Email <small>(required)</small></label>
                                    <input name="email" type="email" class="form-control" placeholder="andrew@email@email.com.com" v-model="form.email" />
                                    <span class="invalid-feedback" v-if="errors && errors.email">{{errors.email[0]}}</span>
                                </div>
                                <div class="form-group">
                                    <label>Phone :</label>
                                    <input name="Phone" type="tel" class="form-control" placeholder="+1 9090909090" v-model="form.phone" />
                                    <span class="invalid-feedback" v-if="errors && errors.phone">{{errors.phone[0]}}</span>
                                </div>
                            </div>

                        </div>

                        <div class="col-sm-5 col-sm-offset-6">
                            <br>
                            <input type='submit' class='btn btn-finish btn-primary' name='finish' value='Finish' />
                        </div>
                        <br>
                    </form>

                </div>
            </div><!-- end row -->

        </div>
    </div>
</template>

<script>
import {reactive, ref} from "vue";
import {useAuthStore} from "../../../store/auth";
import {useToastError} from "../../../composables/useToastError";

export default {
    name: "EditProfile",
    setup() {
        const store = useAuthStore();
        const {toast} = useToastError();

        const form = reactive({
            name: store.$state.user.name,
            email: store.$state.user.email,
            phone: store.$state.user.phone
        });

        const errors = ref(null);

        function submit() {
            errors.value = null;

            window.axios.get(window.sanctumEndpoint).then(() => {
                window.axios.put("/api/user", form).then(response => {
                    toast.success("Profile updated successfully!");
                    store.updateUser(response.data.user);
                }).catch(error => {
                    toast.error('Something wrong is happened');

                    if(error.response.data.errors) {
                        errors.value = error.response.data.errors;
                    }
                });
            });
        }

        return {
            submit,
            form,
            store,
            errors
        }
    }
}
</script>

<style>
.invalid-feedback {
    font-size: .875em;
    color: #dc3545;
}
</style>
